import CrudPage from "./CrudPage";

const Payments = () => (
  <CrudPage
    title="Zahlungen"
    resource="payments"
    testId="admin-payments"
    columns={[
      { key: "payment_date", label: "Datum" },
      { key: "student_id", label: "Schüler ID" },
      { key: "amount", label: "Betrag CHF" },
      { key: "payment_type", label: "Art" },
      { key: "status", label: "Status" },
      { key: "period", label: "Zeitraum" },
    ]}
    fields={[
      { key: "student_id", label: "Schüler ID", required: true },
      { key: "course_id", label: "Kurs ID" },
      { key: "workshop_id", label: "Workshop ID" },
      { key: "amount", label: "Betrag CHF", type: "number", required: true },
      { key: "payment_type", label: "Zahlungsart", type: "select", options: [{ value: "twint", label: "TWINT" }, { value: "cash", label: "Bar" }, { value: "bank", label: "Banküberweisung" }] },
      { key: "payment_date", label: "Datum", type: "date", required: true },
      { key: "period", label: "Monat / Quartal (z.B. 2026-02)" },
      { key: "status", label: "Status", type: "select", options: [{ value: "open", label: "Offen" }, { value: "partial", label: "Teilbezahlt" }, { value: "paid", label: "Bezahlt" }] },
      { key: "note", label: "Bemerkung", type: "textarea", full: true },
    ]}
    defaults={{ student_id: "", course_id: "", workshop_id: "", amount: 0, payment_type: "twint", payment_date: "", period: "", status: "paid", note: "" }}
  />
);

export default Payments;
